import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { corefetch } from "../../Util/axios_core_helper";

const initialState = {
  displayinDDList: [],
  displayinListLoaded: false,
  seldisplayinID: [],
};

export const getdisplayinList = createAsyncThunk(
  "getdisplayinList",
  async () => {
    return await corefetch("WelcomeSection/GetDisplayesInList");
  }
);
const aboutSlice = createSlice({
  name: "GetaboutUS",
  initialState: initialState,
  reducers: {
    onAboutusedit: (state, action) => {
      try {
        let data = action.payload;
        if (data) {
          let id = data.id ? data.id : [];
          state.seldisplayinID = id;
        } else {
          state.seldisplayinID = [];
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getdisplayinList.pending, (state) => {
      state.displayinListLoaded = false;
    });

    builder.addCase(getdisplayinList.fulfilled, (state, data) => {
      state.displayinDDList = data.payload;
      state.displayinListLoaded = true;
    });

    builder.addCase(getdisplayinList.rejected, (state) => {
      state.displayinDDList = [];
      state.displayinListLoaded = true;
    });
  },
});
export const { onAboutusedit } = aboutSlice.actions;
export default aboutSlice.reducer;
